
import { EMPTY_REQUEST_SERVICE_CODE_ENTITY, RequestServiceCodeEntity } from "domain/entity/RequestServiceCode/RequestServiceCodeEntity";
import { BaseViewChangeSate } from "../BaseViewChangeState";

export interface RequestServiceCodeModel {
    isLoading: boolean,
    requestServiceCodeList: RequestServiceCodeEntity[],
    isShowEditPanel: boolean,
    isEdit: boolean,
    isAdd: boolean,
    selectedRows: RequestServiceCodeEntity[],
    currentRow: RequestServiceCodeEntity,
    currentEditRow: RequestServiceCodeEntity,
    masterState: RequestServiceCodeViewChangeState
}
export interface RequestServiceCodeViewChangeState extends BaseViewChangeSate {
}
export const EMPTY_REQUEST_SERVICE_CODE_MODEL: RequestServiceCodeModel = {
    isLoading: false,
    requestServiceCodeList: [],
    isShowEditPanel: false,
    isEdit: false,
    isAdd: false,
    selectedRows: [],
    currentRow: { ...EMPTY_REQUEST_SERVICE_CODE_ENTITY },
    currentEditRow: { ...EMPTY_REQUEST_SERVICE_CODE_ENTITY },
    masterState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        }
    }
}